function setErrorObserver(element, callback) {
  if (!element) return;
  // @ts-ignore
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const observer = new MutationObserver(function (mutations) {
    // eslint-disable-next-line no-restricted-syntax
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const pageCrashed = !mutation.target.classList.contains('hidden');
        callback(pageCrashed, observer);
      }
    }
  });
  observer.observe(element, {
    attributes: true,
  });
}

export default setErrorObserver;
